module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlLz48L2RlZnM+PHBhdGggZD0iTTMxOC41NzggODE5LjJMMTcuMDY3IDUxMmwzMDEuNTEtMzA3LjIgNDUuNTEyIDQ1LjUxMUw5Ni43MSA1MTIgMzY0LjA5IDc3My42ODl6bTM4Ni44NDQgMGwtNDUuNTEtNDUuNTExTDkyNy4yODggNTEyIDY1OS45MSAyNTAuMzExbDQ1LjUxMS00NS41MTFMMTAwNi45MzMgNTEyek01NDAuNzg2IDIyMS44NjdsNTUuNzUgMTEuMTUtMTEzLjM3OSA1NjkuMTE2LTU1Ljc1LTExLjA5M3oiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/code.svg
// module id = IX5Q
// module chunks = 72